/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationStoreInAppEGSEgsInAppBillingData interface.
 */
export function instanceOfFxIdApplicationStoreInAppEGSEgsInAppBillingData(value) {
    if (!('EntitlementId' in value) || value['EntitlementId'] === undefined)
        return false;
    if (!('AccessToken' in value) || value['AccessToken'] === undefined)
        return false;
    if (!('Sku' in value) || value['Sku'] === undefined)
        return false;
    if (!('IsConsumeByCatalogItemId' in value) || value['IsConsumeByCatalogItemId'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreInAppEGSEgsInAppBillingDataFromJSON(json) {
    return FxIdApplicationStoreInAppEGSEgsInAppBillingDataFromJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppEGSEgsInAppBillingDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'EntitlementId': json['EntitlementId'],
        'AccessToken': json['AccessToken'],
        'DeveloperPayload': json['DeveloperPayload'] == null ? undefined : json['DeveloperPayload'],
        'Sku': json['Sku'],
        'IsConsumeByCatalogItemId': json['IsConsumeByCatalogItemId'],
    };
}
export function FxIdApplicationStoreInAppEGSEgsInAppBillingDataToJSON(json) {
    return FxIdApplicationStoreInAppEGSEgsInAppBillingDataToJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppEGSEgsInAppBillingDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'EntitlementId': value['EntitlementId'],
        'AccessToken': value['AccessToken'],
        'DeveloperPayload': value['DeveloperPayload'],
        'Sku': value['Sku'],
        'IsConsumeByCatalogItemId': value['IsConsumeByCatalogItemId'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreInAppEGSEgsInAppBillingData.js.map